<div class="authentication-content">
  <router-outlet></router-outlet>
  <app-authentication-footer></app-authentication-footer>
</div>
